"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fontWeight = _interopRequireDefault(require("./fontWeight"));

var _typography = _interopRequireDefault(require("./typography"));

var _colors = _interopRequireDefault(require("./colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var baseFont = {
  fontSize: _typography["default"].paragraph[2].fontMobile,
  fontWeight: _fontWeight["default"][2],
  color: _colors["default"].monochrome6["default"],
  backgroundColor: _colors["default"].monochrome2["default"],
  fontFamily: 'Vodafone, Open Sans, sans-serif',
  lineHeight: _typography["default"].paragraph[2].lineHeightMobile
};
var _default = baseFont;
exports["default"] = _default;
//# sourceMappingURL=baseFont.js.map